import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { EditPermissions } from '../../../../../../../shared/models';
import { getEditTypes } from '../../../delegatorUtils';
import { newStepValue } from '../../../../../services/flowBuilder/utils/constants';
import { required } from '../../../../../../../shared/utils';

export interface externalLinkData {
  text: string,
  url: string
}

export interface logicData {
  next: string;
  result: string;
  description: string;
}

export interface ExternalLinkForms {
  ExternalLinkForm: FormGroup,
  LogicForm: FormGroup
}

export class ExternalLink {
  private menu: any = {};

  constructor() {
    this.menu = {
      'menuType': 'externalLink',
    };
  }

  static toForm(stepData: { [index: string]: any }, editPermissions: EditPermissions): ExternalLinkForms {
    const { editMenuTextOnly, editFlows } = getEditTypes(editPermissions);
    const formData = this.getFromData(stepData);
    const logicData = this.getLogicData(stepData);

    return {
      ExternalLinkForm: this.buildForm(formData, editFlows),
      LogicForm: this.buildLogicForm(logicData, editFlows),
    };
  }

  private static getFromData(stepData: { [index: string]: any }): externalLinkData {
    const menu = stepData?.menu ? stepData?.menu : {};

    return {
      text: this.getOrDefault(menu?.text),
      url: this.getOrDefault(menu?.url),
    };
  }

  private static getLogicData(stepData: { [index: string]: any }): logicData[] {
    const menu = stepData?.menu ? stepData?.menu : {};

    const results = menu?.results ? menu?.results : {
      other: {
        next: newStepValue,
        description: 'ERROR',
      },
    };

    const logicData: logicData[] = [];

    for (const key in results) {
      if (results.hasOwnProperty(key)) {
        const result = results[key];
        result['result'] = key;
        logicData.push(result);
      }
    }

    return logicData;
  }

  private static getOrDefault(value: string, defaultValue: any = ''): any {
    if (value === undefined || !value) {
      return defaultValue;
    }

    return value;
  }

  private static buildForm(formData: externalLinkData, editFlows: boolean): FormGroup {
    return new FormGroup({
      text: new FormControl({
        value: formData.text,
        disabled: !editFlows,
      }),
      url: new FormControl({
        value: formData.url,
        disabled: !editFlows,
      }, required('URL')),
    });
  }

  private static buildLogicForm(logicData: logicData[], editFlows: boolean): FormGroup {
    const resultArray = [];

    logicData.forEach(item => {
      resultArray.push(this.buildResultGroup(item.result, item.description, item.next, editFlows));
    });

    return new FormGroup({
      results: new FormArray(resultArray),
    });
  }

  public static buildResultGroup(resultName: string, description: string, next: string, editFlows: boolean): FormGroup {
    if (resultName === 'other') {
      return new FormGroup({
        result: new FormControl({
          value: resultName,
          disabled: true,
        }),
        description: new FormControl({
          value: description,
          disabled: true,
        }),
        next: new FormControl({
          value: next,
          disabled: !editFlows,
        }),
      });
    } else {
      return new FormGroup({
        result: new FormControl({
          value: resultName,
          disabled: !editFlows,
        }),
        description: new FormControl({
          value: description,
          disabled: !editFlows,
        }),
        next: new FormControl({
          value: next,
          disabled: !editFlows,
        }),
      });
    }
  }

  get nodeData(): {} {
    return {
      menu: this.menu,
      'type': 'menu',
      metadata: {
        nodeVersion: '1.0.0',
      },
    };
  }
}